import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=6f7ee3c2"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"
import style0 from "./Tile.vue?vue&type=style&index=0&id=6f7ee3c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports